import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';

export class RequestWorkspaceUserInvitationDelete extends DTO__base {
  static _class_name_static: string = 'REQUEST_WORKSPACE_USER_INVITATION_DELETE';

  workspace_id!: string;
  invitation_id!: string;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.invitation_id);
  }
}
